import {LoadingButton} from '@mui/lab';
import {Add} from '@mui/icons-material';
import {useTranslation} from 'react-i18next';
import {translations} from '../../../i18n/translations';

export function LogsLoadMoreBtn(props: {
  onClick?: (evt: React.MouseEvent<HTMLButtonElement>) => void;
}) {
  const {t} = useTranslation();

  return (
    <LoadingButton
      color="primary"
      size="small"
      className="load-more-button"
      endIcon={<Add />}
      onClick={props.onClick}
    >
      {t(translations.dynamic_form.feature_fields.autocomplete.load_more)}
    </LoadingButton>
  );
}
